export default __webpack_public_path__ + "static/media/1843.a9d98360.png";